import React, { useState } from "react";
import { getAuth, updatePassword } from "firebase/auth";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FiLock, FiSave } from "react-icons/fi";

const MySwal = withReactContent(Swal);
const Toast = MySwal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 2500, timerProgressBar: true, iconColor: '#10b981', customClass: { popup: 'tw-bg-white tw-rounded-xl tw-shadow-lg tw-border tw-border-slate-100 tw-px-4 tw-py-3', title: 'tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0' } });

export default function MySettings() {
    const [passwordForm, setPasswordForm] = useState({ newPassword: "", confirmPassword: "" });
    const [isSaving, setIsSaving] = useState(false);
    const auth = getAuth();

    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        if (passwordForm.newPassword !== passwordForm.confirmPassword) return Toast.fire({ icon: 'warning', title: 'Нууц үг хоорондоо таарахгүй байна.' });
        if (passwordForm.newPassword.length < 6) return Toast.fire({ icon: 'warning', title: 'Нууц үг хамгийн багадаа 6 тэмдэгт байна.' });

        setIsSaving(true);
        try {
            await updatePassword(auth.currentUser, passwordForm.newPassword);
            Toast.fire({ icon: 'success', title: 'Нууц үг амжилттай солигдлоо!' });
            setPasswordForm({ newPassword: "", confirmPassword: "" });
        } catch (error) {
            if (error.code === 'auth/requires-recent-login') {
                MySwal.fire({ icon: 'warning', title: 'Аюулгүй байдал', text: 'Таны нэвтэрсэн хугацаа удсан байна. Та системээс гараад дахин нэвтэрч ороод нууц үгээ солино уу.', confirmButtonText: 'Ойлголоо', confirmButtonColor: '#3b82f6' });
            } else { Toast.fire({ icon: 'error', title: 'Алдаа гарлаа: ' + error.message }); }
        } finally { setIsSaving(false); }
    };

    return (
        // ⭐️ ЭНД АРЫН ӨНГӨ БОЛОН ӨНДРИЙГ НЭМСЭН
        <div className="tw-bg-slate-50 tw-min-h-screen tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-font-sans tw-text-slate-800">
            <div className="tw-max-w-2xl tw-mx-auto">
                <div className="tw-bg-white tw-rounded-3xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-animate-fade-in-up">
                    <div className="tw-px-6 tw-py-5 tw-border-b tw-border-slate-100 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-3">
                        <FiLock className="tw-text-blue-600" size={20} />
                        <div>
                            <h3 className="tw-text-base tw-font-black tw-text-slate-800 tw-m-0">Нууц үг солих</h3>
                            <p className="tw-text-[11px] tw-text-slate-500 tw-m-0 tw-mt-0.5">Та өөрийн анхны нууц үгийг солих шаардлагатай.</p>
                        </div>
                    </div>
                    
                    <form onSubmit={handleUpdatePassword} className="tw-p-6 sm:tw-p-8 tw-flex tw-flex-col tw-gap-6">
                        <div>
                            <label className="tw-block tw-text-xs tw-font-bold tw-text-slate-600 tw-mb-2 tw-uppercase">Шинэ нууц үг</label>
                            <input 
                                type="password" required minLength="6" placeholder="Хамгийн багадаа 6 тэмдэгт"
                                value={passwordForm.newPassword} onChange={(e) => setPasswordForm({...passwordForm, newPassword: e.target.value})} 
                                className="tw-w-full tw-px-4 tw-py-3 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-xl tw-text-sm tw-font-bold tw-text-slate-800 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-bg-white tw-transition-colors" 
                            />
                        </div>
                        <div>
                            <label className="tw-block tw-text-xs tw-font-bold tw-text-slate-600 tw-mb-2 tw-uppercase">Нууц үг дахин давтах</label>
                            <input 
                                type="password" required minLength="6" placeholder="Шинэ нууц үгээ дахин бичнэ үү"
                                value={passwordForm.confirmPassword} onChange={(e) => setPasswordForm({...passwordForm, confirmPassword: e.target.value})} 
                                className="tw-w-full tw-px-4 tw-py-3 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-xl tw-text-sm tw-font-bold tw-text-slate-800 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-bg-white tw-transition-colors" 
                            />
                        </div>

                        <div className="tw-mt-4 tw-flex tw-justify-end tw-pt-6 tw-border-t tw-border-slate-100">
                            <button type="submit" disabled={isSaving || !passwordForm.newPassword || !passwordForm.confirmPassword} className="tw-px-8 tw-py-3 tw-bg-slate-900 hover:tw-bg-black tw-text-white tw-rounded-xl tw-font-bold tw-text-sm tw-flex tw-items-center tw-gap-2 tw-shadow-lg tw-transition-all disabled:tw-opacity-50">
                                <FiSave size={18}/> {isSaving ? "Сольж байна..." : "Нууц үг хадгалах"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}